import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import { Modal, Typography, Ratings } from '@hpi-sox/hpstellar-core';
import { Cross } from '@hpi-sox/hpstellar-icons';

import ProductImage from '../../product/components/product-image';
import Link from '../../ui/components/link';

import { Helpers } from '../../core/src/helpers';
import { memoizedFormatMetricValue } from '../../metrics/metrics-helpers';
import './css/dlp-reviews.less';

class DLPReviews extends React.PureComponent {
    state = {
        modalProduct: null,
    };

    toggleModalView = product => this.setState({ modalProduct: product });

    renderProductImage = ({ images }) => images;

    closeModal = () => {
        this.toggleModalView(null);
    };

    renderProductReview = (product, isModal) => {
        let { reviews, images, sku, name, linkUrl } = product || {};
        let { text, rating, user, lastSubmissionTime } = reviews && reviews[0] ? reviews[0] : {};
        let image = images && images[0];
        return (
            text &&
            text.length > 0 && (
                <div key={`dlp-review-${sku}`} className="dlp-reviews-tile">
                    {isModal && (
                        <button type="button" className="closeButton" aria-label="Close" onClick={this.closeModal}>
                            <Cross size="m" />
                        </button>
                    )}
                    <div className="dlp-reviews-image-container">
                        <ProductImage
                            product={{
                                images: [{ lrg: image.src }],
                                sku,
                                name,
                            }}
                            link={linkUrl}
                            linkType="relative"
                            lazyLoad={true}
                            maxImgWidth={270}
                            ImageWrapper={this.renderProductImage}
                        />
                    </div>
                    <div className="dlp-reviews-summary-container">
                        <h2>{name}</h2>
                        <div className="dlp-rating-container product-card-detail">
                            <div className="reviews-row product-review">
                                <Ratings score={rating} />
                            </div>
                        </div>
                        {isModal ? (
                            <div className="dlp-review-summary-container">{text}</div>
                        ) : (
                            <div className="dlp-review-summary-container">
                                <Dotdotdot clamp={5}>
                                    <span>{text}</span>
                                </Dotdotdot>
                            </div>
                        )}
                        {isModal ? (
                            <div className="dlp-review-user-info">
                                {' '}
                                <div className="dlp-review-user">{user}</div>{' '}
                                {lastSubmissionTime ? (
                                    <div>{`${new Date(lastSubmissionTime).toLocaleDateString()}`}</div>
                                ) : (
                                    ''
                                )}
                            </div>
                        ) : (
                            <Link
                                className="with-hover"
                                onClick={() => this.toggleModalView(product)}
                                data-gtm-category="readReview"
                                name={memoizedFormatMetricValue(name)}
                            >
                                READ THE REVIEW
                            </Link>
                        )}
                    </div>
                </div>
            )
        );
    };

    getProductReviews = Helpers.memoize(
        results => {
            try {
                return results.reduce((productReviews, product) => {
                    let productReview;
                    if (productReviews.length < 4) {
                        productReview = this.renderProductReview(product);
                    }

                    if (productReview) {
                        productReviews.push(productReview);
                    }
                    return productReviews;
                }, []);
            } catch (e) {}

            return null;
        },
        (results, keyword) => `${keyword}-${results && results.length}`
    );

    render() {
        let { results, keyword } = this.props;
        let { modalProduct } = this.state;
        let reviews = this.getProductReviews(results, keyword);

        return (
            reviews &&
            reviews.length >= 2 && (
                <div className="dlp-reviews-wrapper">
                    <div className="dlp-reviews-container">
                        {keyword && keyword.length > 0 && (
                            <Typography
                                variant="display"
                                tag="h2"
                                className="dlp-reviews-header"
                            >{`Recent ${keyword} Reviews`}</Typography>
                        )}
                        <div className="dlp-reviews">{reviews}</div>
                        <Modal
                            isOpen={!!modalProduct}
                            withBackdrop
                            verticalAlignment="center"
                            horizontalAlignment="center"
                            className="dlp-review-modal"
                            onModalClose={this.closeModal}
                        >
                            {this.renderProductReview(modalProduct, true)}
                        </Modal>
                    </div>
                </div>
            )
        );
    }
}

export default DLPReviews;
